/**
 * DSC Travel — Design Tokens v5
 * 
 * Paleta e tipografia conforme Brand Identity Guide.
 * Fonte display: Bodoni Moda (substituta da Riffle Free)
 * Fonte corpo:   Raleway
 */

export const colors = {
  // Paleta v5 (dark UI)
  brandIndigo: '#09077d',
  deep:    '#060550',
  deepBg:  '#05043d',
  mid:     '#0b0969',
  surface: '#0e0b7a',
  slate:   '#8b8ec4',
  silver:  '#b8bade',
  cream:   '#d8d9ef',
  white:   '#f0f0f8',
  accent:  '#50cfad',
  accentSoft: 'rgba(80, 207, 173, 0.12)',
  warm:    '#ffbc15',

  // Legado (compatibilidade com Dashboard, etc.)
  primary: '#090777',
  background: '#f8fafc',
  card: '#ffffff',
  border: '#e2e8f0',
  text: {
    primary: '#0f172a',
    secondary: '#64748b',
    muted: '#94a3b8'
  },
  status: {
    active: '#50cfad',
    expired: '#e2e8f0'
  }
};

export const fonts = {
  display: "'Bodoni Moda', 'Riffle Free', Georgia, serif",
  body:    "'Raleway', -apple-system, sans-serif",
};

export const tracking = {
  tight:   '-0.02em',
  display: '0.04em',
  wide:    '0.06em',
  wider:   '0.12em',
};

export const spacing = {
  xs: '0.25rem',
  sm: '0.5rem',
  md: '1rem',
  lg: '1.5rem',
  xl: '2rem'
};

export const borderRadius = {
  sm: '0.5rem',
  md: '0.75rem',
  lg: '1rem',
  full: '9999px'
};
